import { ISwapPathInfo } from "../../../../../api/swap";

const createSingleSwapPath = (targetPathInfo: ISwapPathInfo) => {
  const info = targetPathInfo.swap_path[0];
  const result = [
    String(info.asset_name_from),
    String(info.fee),
    String(info.asset_name_to),
  ];

  return result;
};

const createMultipleSwapPaths = (targetPathInfo: ISwapPathInfo) => {
  const swapPathsLength = targetPathInfo.swap_path?.length;
  let result: string[] = [];

  for (let i = 0; i < swapPathsLength; i++) {
    const info = targetPathInfo.swap_path[i];

    if (i === 0) {
      result = [
        String(info.asset_name_from),
        String(info.fee),
        String(info.asset_name_to),
      ];
      continue;
    }

    result.push(String(info.fee), String(info.asset_name_to));
  }

  return result;
};

export const getApiSwapPath = (
  swapPaths: ISwapPathInfo[],
  fromCurrency: string,
  toCurrency: string
) => {
  const targetPathInfo = swapPaths.find((pathInfo) => {
    return (
      pathInfo.asset_name_from === fromCurrency &&
      pathInfo.asset_name_to === toCurrency
    );
  });

  if (!targetPathInfo) {
    return [];
  }

  return JSON.parse(targetPathInfo.contract_swap_path);
};
